import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { Store } from '@ngxs/store';
import { combineLatest, distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { EnedisAccessRightModel } from '../../enedis.models';
import { EnedisState } from '../../enedis.state';

interface TabsItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

@UntilDestroy()
@Component({
    selector: 'app-enedis-meter',
    templateUrl: './enedis-meter.component.html',
    styleUrls: ['./enedis-meter.component.scss'],
})
export class EnedisMeterComponent {
    title = '';
    subTitle = '';
    public enedisAccessRight$: Observable<EnedisAccessRightModel> = inject(Store)
        .select(EnedisState.currentAccessRight)
        .pipe(filter(Boolean));
    public currentAccessRightId = '';

    public tabItems: TabsItem[] = [
        {
            display: 'Données techniques',
            routerLink: [`./informations`],
            routerLinkActiveOptions: { exact: false },
        },
        {
            display: 'Consommations',
            routerLink: [`./consumption`],
            routerLinkActiveOptions: { exact: false },
        },
        {
            display: 'Profils',
            routerLink: [`./profil`],
            routerLinkActiveOptions: { exact: false },
        },
    ];

    constructor(
        private readonly route: ActivatedRoute,
        private readonly sidenavService: SidenavService,
        private readonly store: Store,
    ) {
        this.enedisAccessRight$.pipe(untilDestroyed(this)).subscribe((enedisAccessRight) => {
            this.currentAccessRightId = enedisAccessRight.id;
            this.subTitle = `PRM n° ${enedisAccessRight.pdlNumber}`;
            if (enedisAccessRight.clientName) {
                this.title = `${enedisAccessRight.clientName}`;
            } else {
                this.title = `${enedisAccessRight.clientRepresentativeName}`;
            }
        });
    }
}
